import { PerformingIdea } from '../../../../../apis/statistics/statistics-api.def.ts'

export interface PreparedPerformingIdeas {
  topIdeas: PerformingIdea[]
  bottomIdeas: PerformingIdea[]
  allZero: boolean
}

export function pnlAllZero(ideas: PerformingIdea[]): boolean {
  return ideas.every((idea) => idea.totalPnl === 0)
}

export function preparePerformingIdeasData(
  topIdeas: PerformingIdea[],
  bottomIdeas: PerformingIdea[]
): PreparedPerformingIdeas {
  const allZero = pnlAllZero(topIdeas) && pnlAllZero(bottomIdeas)

  const sortedTopIdeas = [...topIdeas]
    .filter((idea) => idea.totalPnl > 0)
    .sort((a, b) => a.totalPnl - b.totalPnl)

  const sortedBottomIdeas = [...bottomIdeas]
    .filter((idea) => idea.totalPnl < 0)
    .sort((a, b) => b.totalPnl - a.totalPnl)

  return {
    topIdeas: sortedTopIdeas,
    bottomIdeas: sortedBottomIdeas,
    allZero,
  }
}
